<template>
  <v-snackbar
    v-model="show"
    :timeout="timeout"
    :color="snackbarColor"
    location="top right"
    variant="elevated"
    class="modern-snackbar"
    :class="snackbarClass"
  >
    <div class="d-flex align-center">
      <v-icon 
        :icon="snackbarIcon" 
        size="small" 
        class="mr-3"
        :color="iconColor"
      ></v-icon>
      <div class="flex-grow-1">
        <div class="font-weight-medium text-body-2">{{ message }}</div>
      </div>
      <v-btn
        icon="mdi-close"
        variant="text"
        size="small"
        :color="iconColor"
        @click="show = false"
        class="ml-2"
      ></v-btn>
    </div>
  </v-snackbar>
</template>

<script>
export default {
  inject: ['bus'],
  data() {
    return {
      show: false,
      message: '',
      isError: false,
      timeout: 4000
    }
  },
  computed: {
    snackbarColor() {
      return this.isError ? 'error' : 'success'
    },
    snackbarIcon() {
      return this.isError ? 'mdi-alert-circle' : 'mdi-check-circle'
    },
    iconColor() {
      return 'white'
    },
    snackbarClass() {
      return this.isError ? 'error-snackbar' : 'success-snackbar'
    }
  },
  mounted() {
    this.bus.on('modernSnackBarMsg', (data) => {
      this.message = data.msg
      this.isError = data.error
      this.timeout = data.timeout || 4000
      this.show = true
    })
  },
  beforeUnmount() {
    this.bus.off('modernSnackBarMsg')
  }
}
</script>

<style scoped>
.modern-snackbar {
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
}

.modern-snackbar :deep(.v-snackbar__wrapper) {
  border-radius: 12px;
  min-width: 320px;
  max-width: 480px;
}

.success-snackbar :deep(.v-snackbar__wrapper) {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%) !important;
  border-left: 4px solid #2E7D32;
}

.error-snackbar :deep(.v-snackbar__wrapper) {
  background: linear-gradient(135deg, #f44336 0%, #d32f2f 100%) !important;
  border-left: 4px solid #C62828;
}

.modern-snackbar :deep(.v-snackbar__content) {
  padding: 8px 16px;
  min-height: auto;
}

.modern-snackbar :deep(.v-snackbar__wrapper) {
  min-height: 48px;
}
</style>